import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

export type HxCardActionsAlign = 'start' | 'center' | 'end' | 'space-between';

/** Card actions (footer) section component */
@Component({
  selector: 'hx-card-actions',
  standalone: true,
  templateUrl: './card-actions.component.html',
  host: {
    class: 'hx-card__actions',
    '[class.hx-card__actions--align-start]': 'align() === "start"',
    '[class.hx-card__actions--align-center]': 'align() === "center"',
    '[class.hx-card__actions--align-end]': 'align() === "end"',
    '[class.hx-card__actions--align-space-between]': 'align() === "space-between"',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HxCardActionsComponent {
  /** Alignment of action buttons within the card footer */
  readonly align = input<HxCardActionsAlign>('start');
}
